export const appEnv = {
  isTests: Boolean(process.env.REACT_APP_IS_TEST)
};
